import React from 'react';

import { UISystemIcon } from '@futrli/ui-components';

import * as styles from './right-banner.scss';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

export const RightBanner = () => {
  return (
    <div className={classNames(styles.container)}>
      <UISystemIcon iconName="quote" width={68} height={48} />
      <div style={{ height: 32 }} />
      <div className={styles.title}>
        <FormattedMessage id="register.futrli_humanises_the_numbers" defaultMessage="Futrli humanises the numbers" />
      </div>
      <div style={{ margin: '24px 0' }}>
        <FormattedMessage
          id="register.promotion_text"
          defaultMessage="There aren’t any other tools that can be so widely used from beginner to expert. It’s a jargon-free way of communicating to your clients."
        />
      </div>
      <div className={styles.heading}>
        <FormattedMessage id="register.client_name" defaultMessage="Stuart Hurst" />
      </div>
    </div>
  );
};
